import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

const linkDefs = [
  { key: "overview", num: "01", target: "overview" },
  { key: "philosophy", num: "02", target: "philosophy" },
  { key: "orbtech", num: "03", target: "orbtech" },
  { key: "contact", num: "04", target: "contact" },
];

export default function MenuOverlay({ open, onClose, onNavigate }) {
  const { t } = useI18n();
  const links = linkDefs.map((l) => ({ ...l, label: t.menu[l.key] }));
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[70] bg-[#050505]"
          data-testid="menu-overlay"
        >
          <div className="absolute inset-0 opacity-[0.4] mask-radial-fade">
            <div className="h-full w-full bg-[radial-gradient(circle_at_70%_30%,rgba(168,85,247,0.14),transparent_60%)]" />
          </div>

          <div className="relative flex items-center justify-between px-4 sm:px-6 py-4">
            <span className="font-head text-lg tracking-tight">Orb Holdings Limited</span>
            <button
              onClick={onClose}
              data-testid="menu-close-button"
              className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-md px-3.5 py-2.5 transition-colors duration-300 hover:bg-white/[0.08]"
            >
              <X className="h-4 w-4 text-white" />
              <span className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-white/80">
                {t.menu.close}
              </span>
            </button>
          </div>

          <nav className="relative mt-[6vh] px-6 sm:px-16">
            {links.map((l, i) => (
              <motion.button
                key={l.key}
                data-testid={`menu-link-${l.target}`}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: 0.15 + i * 0.07,
                  duration: 0.7,
                  ease: [0.16, 1, 0.3, 1],
                }}
                onClick={() => onNavigate(l.target)}
                className="group flex w-full items-baseline gap-6 border-b border-white/10 py-5 text-start"
              >
                <span className="font-mono-accent text-xs text-[#a855f7] w-8">
                  {l.num}
                </span>
                <span className="font-head text-3xl sm:text-5xl font-light tracking-tight text-white/60 transition-colors duration-300 group-hover:text-white">
                  {l.label}
                </span>
              </motion.button>
            ))}
          </nav>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
